import React from 'react';
import { Github, Linkedin, Twitter, Mail, MessageCircle } from 'lucide-react'; // Añadimos MessageCircle

const Footer = () => {
  const whatsappNumber = "527295632490";
  const message = encodeURIComponent("Hola Pixelinux, me gustaría recibir más información.");

  return (
    <footer style={{
      background: '#000000',
      borderTop: '1px solid rgba(255, 255, 255, 0.25)',
      padding: '60px 7.6923% 40px',
      position: 'relative'
    }}>
      
      {/* BOTÓN FLOTANTE DE WHATSAPP */}
      <a 
        href={`https://wa.me/${whatsappNumber}?text=${message}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '30px',
          right: '30px',
          backgroundColor: '#25D366', 
          color: '#FFF',
          padding: '12px 20px',
          borderRadius: '50px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          textDecoration: 'none',
          fontWeight: '600',
          fontSize: '14px',
          boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
          zIndex: 9999, // Asegura que esté por encima de todo
          transition: 'transform 0.3s ease'
        }}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
      >
        <MessageCircle size={20} />
        Chat Con Soporte
      </a>

      <div style={{
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '60px',
          marginBottom: '60px'
        }} className="footer-grid">
          
          {/* Brand */}
          <div>
            <div style={{
              fontSize: '28px',
              fontWeight: 600,
              color: '#00FFD1',
              marginBottom: '16px'
            }}>
              PIXELINUX
            </div>
            <p style={{
              fontSize: '16px',
              color: 'rgba(255, 255, 255, 0.85)',
              lineHeight: 1.5,
              marginBottom: '24px'
            }}>
              Soluciones avanzadas de infraestructura Linux para empresas modernas.
            </p>
            <div style={{ display: 'flex', gap: '16px' }}>
              <a href="https://github.com/repos" style={{ color: '#4D4D4D', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#00FFD1'} onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}><Github size={24} /></a>
              <a href="#" style={{ color: '#4D4D4D', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#00FFD1'} onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}><Linkedin size={24} /></a>
              <a href="#" style={{ color: '#4D4D4D', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#00FFD1'} onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}><Twitter size={24} /></a>
              <a href="#" style={{ color: '#4D4D4D', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#00FFD1'} onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}><Mail size={24} /></a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 style={{ fontSize: '18px', fontWeight: 600, color: '#FFFFFF', marginBottom: '20px' }}>Productos</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <li><a href="#products" style={{ color: '#4D4D4D', textDecoration: 'none', fontSize: '16px' }}>DR Platform</a></li>
              <li><a href="#products" style={{ color: '#4D4D4D', textDecoration: 'none', fontSize: '16px' }}>GuardianOS</a></li>
              <li><a href="#products" style={{ color: '#4D4D4D', textDecoration: 'none', fontSize: '16px' }}>Network Optimizer</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 style={{ fontSize: '18px', fontWeight: 600, color: '#FFFFFF', marginBottom: '20px' }}>Empresa</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <li><a href="#features" style={{ color: '#4D4D4D', textDecoration: 'none', fontSize: '16px' }}>Características</a></li>
              <li><a href="#contact" style={{ color: '#4D4D4D', textDecoration: 'none', fontSize: '16px' }}>Contacto</a></li>
              <li><a href="/aviso-de-privacidad" target="_blank" rel="noopener noreferrer" style={{ color: '#4D4D4D', textDecoration: 'none', fontSize: '16px' }}>Aviso de Privacidad</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 style={{ fontSize: '18px', fontWeight: 600, color: '#FFFFFF', marginBottom: '20px' }}>Contacto</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <li style={{ color: '#4D4D4D', fontSize: '16px' }}>soporte@pixelinux.com</li>
              <li style={{ color: '#4D4D4D', fontSize: '16px' }}>+52 729 563 2490</li> {/* Actualizado con el número que me diste */}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.25)',
          paddingTop: '40px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px'
        }} className="footer-bottom">
          <p style={{ fontSize: '14px', color: '#4D4D4D', margin: 0 }}>
            © 2025 PIXELINUX. Todos los derechos reservados.
          </p>
          <div style={{ display: 'flex', gap: '24px' }}>
            <a href="#" style={{ fontSize: '14px', color: '#4D4D4D', textDecoration: 'none' }}>Privacidad</a>
            <a href="#" style={{ fontSize: '14px', color: '#4D4D4D', textDecoration: 'none' }}>Términos</a>
          </div>
        </div>
      </div>

      <style jsx="true">{`
        @media (max-width: 767px) {
          .footer-grid {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
          }
          .footer-bottom {
            flex-direction: column !important;
            align-items: flex-start !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
